module.exports = __webpack_public_path__ + "img/shot_bigtx20022501.7b220908.png";